import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';


export default function SecondCard2() {
  return (
    <div>
      <Accordion sx={{backgroundColor:'#1976d2'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"        
        >         
          <Typography align="center" sx={{width: '100%', fontFamily:'Lucida Sans', fontSize:"1.5em", color:'white'}}>Veja como realizar uma consulta - Clique aqui</Typography>         
        </AccordionSummary>        

        <AccordionDetails sx={{fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            <Typography align="center" sx={{width: '50%', fontFamily:'Lucida Sans', fontSize:20, color:'white'}}>
                Uma maneira de ter uma consulta com Dr. Marcos Soares através do seu plano de saúde é pedir o Reembolso da Consulta
            </Typography>           
        </AccordionDetails>

        <AccordionDetails sx={{fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            <Typography align="center" sx={{width: '70%', fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
                Já ouviu falar no seu seu direito sobre o sistema de reembolso de seu plano de saúde?
            </Typography> 
        </AccordionDetails>

        <AccordionDetails sx={{fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            <Typography align="center" sx={{width: '70%', fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
                Você pode optar pelo  seu  Médico de sua confiança – que não precisa pertencer a nenhum convênio – paga a consulta e num prazo máximo de 30 dias o seu plano de Saúde deve reembolsá-lo.
            </Typography> 
        </AccordionDetails>

        <AccordionDetails sx={{fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            <Typography align="center" sx={{width: '70%', fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
                Se o plano de saúde não cumprir o prazo estipulado, o consumidor pode denunciá-lo. O plano de saúde também deve informar qual é o valor a ser reembolsado. Se não o fizer, o consumidor pode exigir o reembolso integral das consultas, de acordo com o PROCON.
            </Typography> 
        </AccordionDetails>

        <AccordionDetails sx={{fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            <Typography align="center" sx={{width: '70%', fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
                Você deve entrar em contato com o seu Plano de Saúde antes da consulta para se informar sobre o Reembolso. No momento que efetuar o pagamento, solicite o recibo com carimbo do CRM e envie para o plano de saúde para ter o ressarcimento do valor.
            </Typography> 
        </AccordionDetails>

        <AccordionDetails sx={{fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            <Typography align="center" sx={{width: '70%', fontFamily:'Lucida Sans', fontSize:15, color:'white', display:'flex',justifyContent:'center'}}>
            LEMBRE-SE: Ter acesso à saúde é direito seu e você tem o direito de escolher o médico de sua preferência e ser reembolsado pelo plano de saúde !!!
            </Typography> 
        </AccordionDetails>



      </Accordion>
      
    </div>
  );
}
